/**
 * "Add a sample" slots.
 *
 * The slot links to the sample collection, but when the shopper is already on a
 * collection page that link would reload a list they are looking at - so there
 * it just closes the drawer instead.
 *
 * Decided here rather than in Liquid because the drawer's markup is injected by
 * cart.js from a section render, so template.name reflects the URL of that
 * fetch, not the page the shopper is on.
 */
document.addEventListener('click', (event) => {
  const slot = event.target.closest?.('[data-sample-slot]');
  if (!slot) return;

  if (!window.location.pathname.startsWith('/collections/')) return;

  event.preventDefault();
  document.querySelector('.cart-drawer-close[data-close-cart], [data-close-cart]')?.click();
});
